import { Patient } from '@models/patient';

/**
 * Patient.tags（生成モデル上は opaque な PatientTagsItem[]）を
 * 表示・選択に使いやすい { id, name }[] に正規化する。
 * バックエンドは `{ tagId, tag: { id, name } }` 形式で返す。
 */
export const extractPatientTags = (
  patient: Pick<Patient, 'tags'>,
): { id: string; name: string }[] => {
  const raw = (patient.tags ?? []) as {
    tagId?: string;
    tag?: { id?: string; name?: string };
  }[];
  return raw
    .map((t) => ({
      id: t.tag?.id ?? t.tagId ?? '',
      name: t.tag?.name ?? '',
    }))
    .filter((t) => t.id && t.name);
};
